import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { enterpriseClient } from '#pplx_generated/typespec/rest/enterprise/client.js';
export const getRefreshOrgSubscriptionStatus = async ({ headers, reason, }) => {
    try {
        const { data, error, response } = await enterpriseClient.GET('/rest/enterprise/organization/subscription/refresh', reason, {
            headers,
            timeoutMs: 4000,
            // expensive query, not retrying
        });
        if (error) {
            throw new ApiClientsError('API_CLIENTS_ERROR', {
                cause: error,
                status: response.status ?? 0,
                details: {
                    reason,
                },
            });
        }
        return {
            subscriptionStatus: data?.subscription_status ?? null,
        };
    }
    catch (err) {
        logger.error(err);
        return null;
    }
};
//# sourceMappingURL=getRefreshOrgSubscriptionStatus.js.map